import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';
import * as moment from 'moment';
import { combineLatest, forkJoin, Observable, of, Subject } from 'rxjs';
import { map, mergeMap, takeUntil, tap } from 'rxjs/operators';
import { tags } from './../../../../../../../_shared/constants/customTags.const';
import { DATE_CONST } from './../../../../../../../_shared/constants/date-constants.const';
import { AvailabilityStatus } from './../../../../../../../_shared/enums/treatment/availabilityStatus.enum';
import { Asset } from './../../../../../../../_shared/model/asset.model';
import { Contractor } from './../../../../../../../_shared/model/contractor.model';
import { Service } from './../../../../../../../_shared/model/service.model';
import { Slot } from './../../../../../../../_shared/model/slot.model';
import { Subcontractor } from './../../../../../../../_shared/model/subcontractor.model';
import { TreatmentReservationRequest } from './../../../../../../../_shared/model/treatment/treatmentReservationRequest';
import { AssetGroup } from './../../../../../../../_shared/model/utils/assetGroup.model';
import { HelperNavigateService } from './../../../../../../../_shared/services/helper-navigate.service';
import { HelperService } from './../../../../../../../_shared/services/helper.service';
import { GetAndLoadAssets, GetAndLoadSubcontractors } from './../../../../../../../_shared/state/base/base.actions';
import { BaseState } from './../../../../../../../_shared/state/base/base.state';
import { Term } from './../../../../../../../_shared/state/treatment/treatment.actions';
import { CommonService } from './../../../../_services/common.service';

@Component({
    selector: 'trt-wid-m-term-item',
    templateUrl: './trt-wid-m-term-item.component.html',
    styleUrls: ['./trt-wid-m-term-item.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrtWidMTermItemComponent implements OnInit {
    // @Input()
    // set resRequestDataSet(value: TreatmentReservationRequest) {
    //     this.resRequestData = _.cloneDeep(value);
    //     if (this.termItemForm) {
    //         this.createForm();
    //     }
    // }

    @Input()
    termItemForm: FormGroup;

    // public resRequestData: TreatmentReservationRequest = new TreatmentReservationRequest();

    @Input()
    public termNumber = 1;

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onClosePopup = new EventEmitter();

    public availabilityStatus: typeof AvailabilityStatus = AvailabilityStatus;
    // public isExpanded: boolean = false;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public timeInputMask: any = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
    public isSubmited = true;
    // public termItemForm: FormGroup;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public servicesForSubconstractor: any[];
    public assets: Asset[];
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public customTags: any = this.helper.loadCustomTags();
    public allSubcontractors: Subcontractor[];
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public calendarOptions: any = this.helper.getDateSettngs(null);
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public termType: any = tags.TERM_TYPE;
    // public isLoadingTermChecking: boolean = false;
    public assetGroups: AssetGroup[];

    private selectedContractor: Contractor = this.store.selectSnapshot(BaseState.activeContractor);

    constructor(
        public fb: FormBuilder,
        public commonRest: CommonService,
        public store: Store,
        public helper: HelperService,
        public helperNavigate: HelperNavigateService,
    ) {}

    private onDestroy$ = new Subject<void>();

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    ngOnInit() {
        combineLatest([
            this.store.dispatch(new GetAndLoadSubcontractors()).pipe(
                mergeMap(() => this.store.select(BaseState.getAllSubcontractors())),
                // takeUntil(this.onDestroy$),
                tap((subcontractors: Subcontractor[]) => (this.allSubcontractors = subcontractors)),
            ),
            this.loadAllServicesForSubcontractor(this.formData?.selectedSubcontractor).pipe(
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                tap((servicesForSubconstractor: any[]) => {
                    this.servicesForSubconstractor = servicesForSubconstractor;
                }),
            ),
            this.store.dispatch(new GetAndLoadAssets()).pipe(
                mergeMap(() => this.store.select(BaseState.getAssets())),
                tap((assets: Asset[]) => {
                    this.assets = assets;
                    this.assetGroups = this.helper.createAssetGroups(this.assets);
                }),
            ),
        ]).subscribe();
    }

    public onStartTimeChange(): void {
        this.termItemForm.controls.selectedTimeEnd.setValue(this.calcEndTime(this.formData.selectedService, this.formData?.selectedTime));
        this.setFormNotChecked();
    }
    public onServiceChange(): void {
        this.termItemForm.controls.selectedTimeEnd.setValue(this.calcEndTime(this.formData.selectedService, this.formData?.selectedTime));
        this.setFormNotChecked();
    }

    public setFormNotChecked(): void {
        this.termItemForm.controls.availabilityStatus.setValue(AvailabilityStatus.NOT_CHECKED);
    }
    //PUBLIC
    public selectFreeSlot(slot: Slot): void {
        const newTermData: TreatmentReservationRequest = _.cloneDeep(this.formData);
        newTermData.selectedDate = moment(slot.start);
        newTermData.selectedTime = moment(slot.start).format('HH:mm');
        newTermData.selectedTimeEnd = moment(slot.end).format('HH:mm');
        newTermData.availabilityStatus = AvailabilityStatus.FREE;
        this.store.dispatch(new Term.UpdateTerm(newTermData));
    }

    public setDate(event): void {
        this.termItemForm.controls.selectedDateView.setValue(event.start.format(DATE_CONST.format.date.view));
        this.setFormNotChecked();
    }

    public onSubConctractorChange(subcontractor): void {
        if (subcontractor) {
            this.loadAllServicesForSubcontractor(subcontractor)
                .pipe(
                    tap((servicesForSubconstractor: Service[]) => {
                        this.servicesForSubconstractor = servicesForSubconstractor;
                    }),
                )
                .subscribe();
        } else {
            this.servicesForSubconstractor = undefined;
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public equalsAnyById(o1: any, o2: any): boolean {
        if (!o1 || !o2) {
            return;
        }
        return o1.id === o2.id;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public equalsAnyById2(o1: any, o2: any): boolean {
        if (!o1 || !o2) {
            return;
        }
        return o1.id === o2.id;
    }

    //PRIVATE

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private loadAllServicesForSubcontractor(subcontractor: Contractor): Observable<any[]> {
        if (subcontractor != null) {
            const contractorSettingsServices: string[] = this.store.selectSnapshot(BaseState.GetContractorSettings)?.booking?.bookingTypes || [
                'services',
            ];

            // const contractorSettings = _.get(this.storage.getContractorSettings(), 'booking.bookingTypes', [
            //     'services',
            // ]);
            const dataCall = {
                subContractorServices: contractorSettingsServices.includes('services')
                    ? this.commonRest.getServicesForSubcontractor(this.selectedContractor.id, subcontractor.id)
                    : of([]),
                allGroups: contractorSettingsServices.includes('groups')
                    ? this.commonRest.getGroupsForSubContractor(this.selectedContractor.id, subcontractor.id)
                    : of([]),
            };

            return forkJoin(dataCall).pipe(
                takeUntil(this.onDestroy$),
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                map((res: { subContractorServices: any[]; allGroups: any[] }) => {
                    res.subContractorServices = res.subContractorServices.filter(el => !el.isCoupon);
                    // poiscemo pravo storitev
                    if (this.formData.selectedService) {
                        let findService = res.subContractorServices.find(el => el.id === this.formData?.selectedService?.id);

                        if (!findService) {
                            findService = res.allGroups.find(el => el.id === this.formData?.selectedService?.id);
                        }
                        this.formData.selectedService = findService;

                        // this.termItemForm.controls['services'].setValue(this.resRequestData.selectedService);
                    } else {
                        // this.addTermForm.controls['services'].setValue(undefined);
                    }
                    //označi da je nekej skupina, nekej pa storitev za grupiranje v ng-select
                    res.subContractorServices = res.subContractorServices.map(el => {
                        el.type = 'SERVICE';
                        return el;
                    });
                    res.allGroups = res.allGroups.map(el => {
                        el.type = 'GROUP';
                        return el;
                    });
                    return res.allGroups.concat(res.subContractorServices);
                }),
            );
        }
        return of([]);
    }

    public calcEndTime(service: Service, timeFrom: string): string {
        if (service && timeFrom) {
            const serviceFull: Service = this.servicesForSubconstractor.find((s: Service) => s.id == service.id);
            if (!serviceFull) {
                return '00:00';
            }
            return moment(timeFrom, 'HH:mm')
                .add(serviceFull?.length, 'minutes')
                .format('HH:mm');
        }
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onFormValueChange(data: any): void {
        this.store.dispatch(new Term.UpdateTerm(data));
    }
    //potrebujem zato da lahko override-am
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    public changeFormValidation(): void {}

    get formData() {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <any>this.termItemForm.value;
    }
}
